import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var MagnifyingGlassSvg = function MagnifyingGlassSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.174 2a9.174 9.174 0 1 0 5.935 16.168L20.941 22l1.06-1.06-3.833-3.83A9.174 9.174 0 0 0 11.174 2M5.746 5.746A7.676 7.676 0 1 1 16.6 16.6 7.676 7.676 0 0 1 5.746 5.746",
    clipRule: "evenodd"
  }));
};
export var MagnifyingGlass = function MagnifyingGlass(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: MagnifyingGlassSvg
  }));
};